// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1_JTy","checkboxCol":"Table_checkboxCol__3Sm3b","emailCol":"Table_emailCol__3bGC6","actionCol":"Table_actionCol__ZQYnZ"};